import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  .babyMotherInfos {
    align-items: center;
    display: flex;
  }
`
